{
    "DataTable_AreYouSure": "Vuoi davvero eliminare quanto segue? \n \n **{}**",
    "NAME": "LanguageDataTable"
}